import React, { Component } from 'react';
import withStyles from 'react-jss'
import axios from 'axios';
//import Platform from 'react-platform-js'
import Button from '@material-ui/core/Button';
import {STORAGE_URL, API} from "../../config";
import {withContext} from "./StateProvider";

const investorsUploadedFiles = API.service('investors-uploaded-files');
// const investor = API.service('investors');
//const log = API.service('mobileipo-log');

const styles = theme => ({

});


class Document extends Component {
  constructor(props) {
    super(props)

    this.state = {
      passportMessage: null,
      passportStatus: '',
      uploadedCnt: 0,
      uploadProgress: 0,
      whichUpload: 'photograph',
    }

    this.photograph = (this.props.placeholder && this.props.placeholder.length) ? this.props.placeholder : 'assets/images/profile/default_photo.jpg';

    this.uploadFile = this.uploadFile.bind(this)
    this.turnOnCam = this.turnOnCam.bind(this)

  }

  componentDidMount() {
    this.loadDoc(this.props.context.selectedInvestor);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.context.selectedInvestor !== this.props.context.selectedInvestor) {
      this.loadDoc(this.props.context.selectedInvestor);
    }
  }

  loadDoc = () => {
    var app = this;

    investorsUploadedFiles.find({ query: { "_account": this.props.investor, "_fieldname": this.props.type, $limit: 1, $sort: { _timestamp: -1 } } }).then(identification => {
      //console.log(identification);
      if (identification.total > 0) {
        //app.photograph = identification.data[0]._orig_filename;
        app.photograph = identification.data[0]._orig_filename;
        if (this.props.type !== '_avatar') {
          if (identification.data[0]._new_status === "Approved") {
            app.setState({
              passportState: 'buttonStateGreen',
              passportMessage: identification.data[0]._status_comment,
              passportStatus: "Approved"
            })
          } else if (identification.data[0]._new_status === "Not Accepted") {
            app.setState({
              passportState: 'buttonStateRed',
              passportMessage: identification.data[0]._status_comment,
              passportStatus: "Rejected"
            })
          } else {
            app.setState({
              passportState: 'buttonStateOrange',
              passportMessage: identification.data[0]._status_comment,
              passportStatus: "Pending Review"
            })
          }
        } else {
          app.setState({
            passportState: 'buttonStateGreen'
          })
        }
      } else {
        console.log('No Profile Picture Set');
      }
    })
  }

  render() {

    return (
        <React.Fragment>
          {(this.props.showImage === true) &&
          <img src={this.photograph} alt={this.props.label}/>
          }
          <form style={{ visibility: 'hidden',width:1,height:1, overflow:'hidden' }} id="uploadForm" encType="multipart/form-data" onChange={this.uploadFile}>
            <input  type="file" ref="upload" id="file" name="file" />
          </form>
          {(this.props.hideUpload !== true) &&
            <Button size="small" variant="outlined" color="primary" onClick={(this.props.trigger) ? this.props.trigger : this.turnOnCam}>
              Upload
            </Button>
          }
        </React.Fragment>
    )
  }

  takePhoto = (event) => {
    this.setState({ whichUpload: "photograph" });
  }

  uploadFile(event) {
    var controller = this;
    var formData = new FormData();

    formData.append("file", event.target.files[0], event.target.files[0].name);
    formData.append("fieldname", this.props.type);
    formData.append("account", this.props.investor);

    //log.create({ "text": "File Upload: " + event.target.files[0].name + " Investor: " + controller.props.investor + " Type: " + controller.props.label, "meta": controller.state.plat, "source": "EBF", "type": "File Uploaded" });

    var payload = {
      _account: this.props.investor,
      _orig_filename: event.target.files[0].name,
      _status: 1,
      _fieldname: this.props.type,
      _creationdate: new Date(),
      _upload_type: this.props.uploadType
    }

    controller.setState({ whichUpload: controller.state.whichUpload + ' uploading' });
    controller.setState({ uploadProgress: 0 });
    axios.post(STORAGE_URL, formData, {
      headers: {
        'content-type': 'multipart/form-data'
      },
      onUploadProgress: function (progressEvent) {
        controller.setState({ uploadProgress: Math.round((progressEvent.loaded * 100) / progressEvent.total) });
      }
    }).then(i => {
      payload._orig_filename = i.data.img;
      controller.photograph = i.data.img;

      investorsUploadedFiles.create(payload).then(i => {
        if (controller.props.type !== '_avatar') {
          controller.setState({ passportState: 'buttonStateOrange', passportStatus: "Pending Review" });
          controller.setState({ whichUpload: controller.state.whichUpload.replace(' uploading', '') });
        } else {
          controller.setState({ passportState: 'buttonStateGreen', passportStatus: "" });
          controller.setState({ whichUpload: controller.state.whichUpload.replace(' uploading', '') });
        }

        console.log('complete');
        if (typeof this.props.onComplete === 'function') {
          console.log('complete_triggered');

          this.props.onComplete();
        }
      });
    });
  }

  turnOnCam() {
    //var controller = this;
    //log.create({ "text": "Upload Clicked Investor: " + controller.props.investor + " Type: " + controller.props.label, "meta": controller.state.plat, "source": "EBF", "type": "File Upload Clicked" });
    this.refs.upload.click()
  }
}

export default withContext(withStyles(styles)(Document));
